import clsx from 'clsx'
import { useRouter } from 'next/router'
import React from 'react'
import useStyles from './RawHtml.styles'
import { Box } from '@mui/material'

type Props = {
  content?: string | null | React.ReactNode
  className?: string
  dataTestId?: string
}

const RawHtml = React.forwardRef<HTMLDivElement, Props>(({ content, className, dataTestId }, ref) => {
  const router = useRouter()
  const { classes } = useStyles()

  const handleAnchorClick = (e: React.SyntheticEvent<HTMLElement>) => {
    const targetLink = (e.target as HTMLElement).closest('a')
    if (
      targetLink?.href &&
      targetLink.hostname === window.location.hostname &&
      targetLink.protocol === window.location.protocol
    ) {
      // Use router.push for links with same site
      e.preventDefault()
      router?.push(targetLink.pathname)
    }
  }
  // As markdown content can contain custom tags like <u> for underline as it is deprecated, we convert them to standard HTML tags.
  const convertCustomTags = (html: string) => {
    if (typeof html !== 'string') return html
    return html?.replace(/&lt;u&gt;/g, '<u>')?.replace(/&lt;\/u&gt;/g, '</u>')
  }

  const convertedMessage = convertCustomTags(content as string)

  let contentElement: React.ReactNode = null

  if (content) {
    if (typeof content === 'string') {
      contentElement = (
        <Box
          ref={ref}
          className={clsx(classes.content, className)}
          onClick={handleAnchorClick}
          onKeyDown={handleAnchorClick}
          dangerouslySetInnerHTML={{ __html: convertedMessage }}
          data-testId={dataTestId}
        ></Box>
      )
    } else {
      contentElement = (
        <Box
          ref={ref}
          className={clsx(classes.content, className)}
          onClick={handleAnchorClick}
          onKeyDown={handleAnchorClick}
          data-testId={dataTestId}
        >
          {content}
        </Box>
      )
    }
  }

  return contentElement
})
RawHtml.displayName = 'RawHtml'

export default RawHtml
